module.exports = __webpack_public_path__ + "b8767c2f222cef8da728d09d34687e3d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/emmer.mp3
// module id = 29
// module chunks = 0